export default __webpack_public_path__ + "static/media/remove.e2ac2bfb.png";